/**
 * Agentic Payment Airdrop - Shared Constants
 *
 * Centralized configuration values used across airdrop-related components.
 * Following DRY principle - constants are defined once and imported where needed.
 */

// Pagination Configuration
export const ITEMS_PER_PAGE = 100;
export const WALLETS_PER_PAGE = 100;

// Airdrop Limits
export const MAX_RECIPIENTS = 1000;

// External Services
export const HASHSCAN_BASE_URL = "https://hashscan.io";

// Selection Modes for wallet selector
export const SELECTION_MODE = {
  TABLE: "table",
  PASTE: "paste",
};

// Tab identifiers for main navigation
export const TABS = {
  AIRDROP: "airdrop",
  HISTORY: "history",
  REVERSE: "reverse",
};

// Status types for transfers
export const TRANSFER_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
};

// API Endpoints
export const API_ENDPOINTS = {
  AVAILABLE_CURRENCIES: "/admin/agentic_payment_airdrop/available_currencies",
  HEDERA_WALLETS: "/admin/agentic_payment_airdrop/hedera_wallets",
  AIRDROP_HISTORY: "/admin/agentic_payment_airdrop/airdrop_history",
};
